(()=>{
 const menu=document.querySelector('.menu-toggle');
 menu?.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));document.querySelector('.nav').classList.toggle('open',open)});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu?.getAttribute('aria-expanded')==='true'){menu.focus();menu?.setAttribute('aria-expanded','false');document.querySelector('.nav')?.classList.remove('open')}});
 let bites=0;
 const bite=document.querySelector('.bite-control'),holes=document.querySelector('#bite-holes'),stage=document.querySelector('.bite-stage');
 // Eat from the left edge across the square, with overlapping scalloped bites.
 const spots=[.12,.37,.62,.87].flatMap(x=>[.22,.50,.78].map(y=>[x,y]));
 const status=document.querySelector('.bite-status'),meter=document.querySelector('.bite-meter');
 const captions=['CHOMP!','OH, FUDGE.','WORTH IT.','JUST ONE MORE.'];
 bite?.addEventListener('click',()=>{
  if(bites===spots.length){
   holes.replaceChildren();bites=0;stage.dataset.bites='0';stage.classList.remove('chomp','all-gone');
   stage.querySelectorAll('.crumb').forEach(crumb=>crumb.remove());
   bite.textContent='Take a bite ↗';meter.textContent='One bite at a time.';
   status.textContent='A fresh start. Just for you.';return;
  }
  const [x,y]=spots[bites];
  [[0,0,.19],[-.13,-.08,.075],[-.13,.08,.075],[.13,-.08,.075],[.13,.08,.075],[0,-.16,.07],[0,.16,.07]].forEach(([dx,dy,r])=>{
   const c=document.createElementNS('http://www.w3.org/2000/svg','circle');
   c.setAttribute('cx',x+dx);c.setAttribute('cy',y+dy);c.setAttribute('r',r);holes.append(c);
  });
  stage.classList.remove('chomp');void stage.offsetWidth;stage.classList.add('chomp');
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches)for(let i=0;i<7;i++){
   const c=document.createElement('i');c.className='crumb';c.style.left=(x*100)+'%';c.style.top=(y*100+12)+'%';
   c.style.setProperty('--dx',(Math.random()*150-75)+'px');stage.append(c);setTimeout(()=>c.remove(),800);
  }
  bites++;stage.dataset.bites=String(bites);
  const finished=bites===spots.length;
  stage.classList.toggle('all-gone',finished);
  stage.querySelector('.chomp-caption').textContent=finished?'ALL GONE!':captions[(bites-1)%captions.length];
  bite.textContent=finished?'Restart ↺':'One more bite ↗';
  meter.textContent=finished?'Every last bite.':`${bites} of ${spots.length} bites`;
  status.textContent=finished?'All gone! That was worth it. Ready for another?':[
   'Oh, that crisp little top.','Hello, fudgy middle.','Keep going. There’s more chocolate to love.',
   'No judgment. We’d take another bite, too.'
  ][(bites-1)%4];
 });
 document.querySelectorAll('.shop-section, [data-product-filters]').forEach(shop=>{
  const buttons=shop.querySelectorAll('[data-filter]');
  const cards=shop.querySelectorAll('.product-card[data-category]');
  const empty=shop.querySelector('[data-shop-empty]');
  const status=shop.querySelector('[data-filter-status]');
  buttons.forEach(button=>button.addEventListener('click',()=>{
   buttons.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
   let count=0;
   cards.forEach(card=>{
    const show=button.dataset.filter==='all'||card.dataset.category.split(/\s+/).includes(button.dataset.filter);
    card.hidden=!show;
    if(show)count++;
   });
   const message=button.dataset.filter==='limited-edition'?'No limited editions available right now. Check back for something sweet.':'No products available in this selection right now.';
   if(empty){empty.hidden=count>0;empty.textContent=message;}
   if(status)status.textContent=count?count+' product'+(count===1?'':'s')+' shown.':message;
   shop.dispatchEvent(new CustomEvent('moc:products-filtered'));
  }));
 });
 const variant=document.querySelector('[data-variant-select]');
 variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0];const button=document.querySelector('[data-add-button]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to bag ↗';document.querySelector('[data-price]').textContent=option.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',variant.value);history.replaceState({},'',url)});
})();

(()=>{const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const product=document.querySelector('.hero-product');if(product&&!reduced&&matchMedia('(hover:hover)').matches){product.addEventListener('pointermove',e=>{const rect=product.getBoundingClientRect();product.style.setProperty('--tilt-x',((e.clientX-rect.left)/rect.width*10-5)+'deg');product.style.setProperty('--tilt-y',(-((e.clientY-rect.top)/rect.height*8-4))+'deg')});product.addEventListener('pointerleave',()=>{product.style.setProperty('--tilt-x','0deg');product.style.setProperty('--tilt-y','0deg')})}if(!reduced&&'IntersectionObserver'in window){const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('enter-view');io.unobserve(entry.target)}}),{threshold:.15});document.querySelectorAll('.section-head,.texture-copy,.austin-copy,.newsletter>div').forEach(el=>io.observe(el))}})();

(()=>{const filter=new URLSearchParams(location.search).get("filter");if(filter){const button=[...document.querySelectorAll(".filter")].find(b=>b.dataset.filter===filter);button?.click()}})();

(()=>{const button=document.querySelector('.joy-pause');const ribbon=document.querySelector('.joy-ribbon');if(!button||!ribbon)return;const preference=matchMedia('(prefers-reduced-motion: reduce)');function setPaused(paused){ribbon.classList.toggle('paused',paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?'Play scrolling ribbon':'Pause scrolling ribbon');button.textContent=paused?'▶':'Ⅱ'}setPaused(preference.matches);button.addEventListener('click',()=>setPaused(button.getAttribute('aria-pressed')!=='true'));preference.addEventListener('change',e=>setPaused(e.matches))})();

// Product gallery, native dialog, and preview quantity controls.
(()=>{const main=document.querySelector('.photo-zoom img');const zoom=document.querySelector('.photo-dialog');const trigger=document.querySelector('.photo-zoom');document.querySelectorAll('[data-photo]').forEach(button=>button.addEventListener('click',()=>{if(!main)return;main.removeAttribute('srcset');main.src=button.dataset.photo;document.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));trigger?.addEventListener('click',()=>{if(!zoom||!main)return;const image=zoom.querySelector('img');image.src=main.currentSrc||main.src;image.alt=main.alt;zoom.showModal()});zoom?.querySelector('.photo-close')?.addEventListener('click',()=>zoom.close());zoom?.addEventListener('click',e=>{if(e.target===zoom)zoom.close()});zoom?.addEventListener('close',()=>trigger?.focus());document.querySelectorAll('[data-qty]').forEach(button=>button.addEventListener('click',()=>{const input=button.parentElement.querySelector('input');input.value=Math.max(1,Math.min(99,(parseInt(input.value,10)||1)+Number(button.dataset.qty)))}))})();

// Track a stable stage so the moving image never shifts its own hover target.
(() => {
  const motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const initialized = new WeakSet();
  function initialize(root = document) {
    root.querySelectorAll('.chocolate-anatomy-product, [data-chocolate-tilt]').forEach(stage => {
      if (initialized.has(stage)) return;
      initialized.add(stage);
      const chocolate = stage.querySelector('img');
      if (!chocolate) return;
      let frame = 0;
      let x = 0;
      let y = 0;
      function reset() {
        cancelAnimationFrame(frame);
        frame = 0;
        stage.classList.remove('is-exploring');
        chocolate.style.removeProperty('--chocolate-rz');
        chocolate.style.removeProperty('--chocolate-rx');
        chocolate.style.removeProperty('--chocolate-ry');
      }
      stage.addEventListener('pointermove', event => {
        if (!motion.matches || event.pointerType !== 'mouse') return;
        const bounds = stage.getBoundingClientRect();
        x = Math.max(-1, Math.min(1, (event.clientX - bounds.left) / bounds.width * 2 - 1));
        y = Math.max(-1, Math.min(1, (event.clientY - bounds.top) / bounds.height * 2 - 1));
        stage.classList.add('is-exploring');
        if (frame) return;
        frame = requestAnimationFrame(() => {
          chocolate.style.setProperty('--chocolate-rz', `${-.7 + x * .3}deg`);
          chocolate.style.setProperty('--chocolate-rx', `${-y * 2}deg`);
          chocolate.style.setProperty('--chocolate-ry', `${x * 2.5}deg`);
          frame = 0;
        });
      });
      stage.addEventListener('pointerleave', reset);
      stage.addEventListener('pointercancel', reset);
      // Abort listeners when Shopify replaces the section in the theme editor.
      const lifecycle = new AbortController();
      const options = { signal: lifecycle.signal };
      motion.addEventListener('change', reset, options);
      window.addEventListener('blur', reset, options);
      window.addEventListener('scroll', reset, { ...options, passive: true });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(stage)) {
          reset();
          lifecycle.abort();
        }
      }, options);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


/* Compare the two hero treatments without duplicating headings or navigation. */
(() => {
  const initialized = new WeakSet();
  const setup = (scope = document) => {
    scope.querySelectorAll('.moc-hero-compare').forEach(hero => {
      if (initialized.has(hero)) return;
      initialized.add(hero);
      const buttons = hero.querySelectorAll('[data-hero-choice]');
      const motion = hero.querySelector('[data-hero-motion]');
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false;
      const updateMotion = () => {
        hero.classList.toggle('is-motion-paused', paused || preference.matches);
        motion.hidden = hero.dataset.heroStyle !== 'animated' || preference.matches;
        motion.setAttribute('aria-pressed', String(paused));
        motion.innerHTML = paused ? '<span aria-hidden="true">▶</span> Play motion' : '<span aria-hidden="true">Ⅱ</span> Pause motion';
      };
      const choose = style => {
        hero.dataset.heroStyle = style;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.heroChoice === style)));
        updateMotion();
      };
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.heroChoice)));
      motion.addEventListener('click', () => { paused = !paused; updateMotion(); });
      preference.addEventListener('change', updateMotion);
      const controls = hero.querySelector('[data-hero-controls]');
      if (controls) controls.hidden = false;
      choose(hero.dataset.heroStyle);
      const observer = new IntersectionObserver(entries => {
        hero.classList.toggle('is-offscreen', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(hero);
      const unload = event => {
        if (!event.target.contains(hero)) return;
        observer.disconnect();
        preference.removeEventListener('change', updateMotion);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

// Mobile homepage carousel: native scrolling with keyboard and button controls.
(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const mobile=matchMedia('(max-width: 749px)');
 function initialize(root){
  root.querySelectorAll('[data-product-carousel]').forEach(grid=>{
   if(grid.dataset.carouselInitialized)return;
   grid.dataset.carouselInitialized='true';
   const shop=grid.closest('[data-product-filters]');
   const controls=shop.querySelector('[data-carousel-controls]');
   const previous=controls.querySelector('[data-carousel-previous]');
   const next=controls.querySelector('[data-carousel-next]');
   const status=controls.querySelector('[data-carousel-status]');
   const cards=()=>[...grid.querySelectorAll('.product-card')].filter(card=>!card.hidden);
   const position=card=>card.getBoundingClientRect().left-grid.getBoundingClientRect().left+grid.scrollLeft;
   const current=items=>{
    let index=0;
    items.forEach((card,i)=>{if(Math.abs(position(card)-grid.scrollLeft)<Math.abs(position(items[index])-grid.scrollLeft))index=i;});
    return index;
   };
   function update(){
    const items=cards();
    grid.tabIndex=mobile.matches?0:-1;
    controls.hidden=!mobile.matches||items.length<2||grid.scrollWidth<=grid.clientWidth+1;
    if(!items.length){status.textContent='';return;}
    const index=current(items);
    previous.disabled=grid.scrollLeft<=1;
    next.disabled=grid.scrollLeft>=grid.scrollWidth-grid.clientWidth-1;
    const bounds=grid.getBoundingClientRect();
    const fullyVisible=items.map((card,i)=>({rect:card.getBoundingClientRect(),index:i}))
     .filter(item=>item.rect.left>=bounds.left-1&&item.rect.right<=bounds.right+1);
    status.textContent=fullyVisible.length>1
     ?`${fullyVisible[0].index+1}–${fullyVisible[fullyVisible.length-1].index+1} of ${items.length}`
     :`${index+1} of ${items.length}`;
   }
   function move(direction){
    if(!mobile.matches)return;
    const items=cards();
    if(!items.length)return;
    const index=Math.max(0,Math.min(items.length-1,current(items)+direction));
    grid.scrollTo({left:position(items[index]),behavior:reduced.matches?'auto':'smooth'});
   }
   previous.addEventListener('click',()=>move(-1));
   next.addEventListener('click',()=>move(1));
   grid.addEventListener('keydown',event=>{
    if(!mobile.matches||event.target!==grid)return;
    if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
     event.preventDefault();move(event.key==='ArrowLeft'?-1:1);
    }
   });
   let frame;
   grid.addEventListener('scroll',()=>{
    cancelAnimationFrame(frame);frame=requestAnimationFrame(update);
   },{passive:true});
   shop.addEventListener('moc:products-filtered',()=>{
    grid.scrollTo({left:0,behavior:'instant'});requestAnimationFrame(update);
   });
   const observer=new ResizeObserver(update);
   observer.observe(grid);
   const reset=()=>{grid.scrollTo({left:0,behavior:'instant'});update();};
   mobile.addEventListener('change',reset);
   const unload=event=>{
    if(!event.target.contains(grid))return;
    observer.disconnect();
    mobile.removeEventListener('change',reset);
    cancelAnimationFrame(frame);
    document.removeEventListener('shopify:section:unload',unload);
   };
   document.addEventListener('shopify:section:unload',unload);
   update();
  });
 }
 initialize(document);
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
